import { render, staticRenderFns } from "./TeamPowerUps.vue?vue&type=template&id=ad06c932&"
import script from "./TeamPowerUps.vue?vue&type=script&lang=ts&"
export * from "./TeamPowerUps.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports